import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { slide as Menu } from 'react-burger-menu';

import { ROLE_OIS_ADMIN, ROLE_OIS_STAFF, ROLE_MEDIA_OWNER, ROLE_MEDIA_AGENCY, ROLE_CREATIVE_AGENCY } from '../constants';

// menu items
export const campaignSummaryMenuItem = {
  name: 'Campaign Summary',
  url: '/campaign-summary',
  icon: 'layers',
  subMenu: undefined
};

export const qualityAssuranceMenuItem = {
  name: 'Quality Assurance',
  url: '/quality-assurance',
  icon: 'policy',
  subMenu: undefined
};

export const adminMenuItem = {
  name: 'Admin',
  url: '',
  icon: 'admin_panel_settings',
  subMenu: [
    {
      name: 'Agencies',
      url: '/agencies'
    },
    {
      name: 'Vendors',
      url: '/media-owners'
    }
  ]
};

export const reportsMenuItem = {
  name: 'Reports',
  url: '',
  icon: 'description',
  subMenu: [
    {
      name: 'Vendor Performance',
      url: '/reports/publisher-performance'
    }
  ]
};

export const siteManagementMenuItem = {
  name: 'Site Management',
  url: '/site-management',
  icon: 'account_balance',
  subMenu: undefined
};

export const referenceDataMenuItem = {
  name: 'Reference Data',
  url: '/reference-data',
  icon: 'account_balance',
  subMenu: undefined
};

export const formatsMenuItem = {
  name: 'Formats',
  url: '/formats',
  icon: 'dvr',
  subMenu: undefined
};

export const dspsMenuItem = {
  name: 'DSPs',
  url: '/dsps',
  icon: 'inventory_2',
  subMenu: undefined
};

export const advertisersMenuItem = {
  name: 'Advertisers',
  url: '/advertisers',
  icon: 'home_work',
  subMenu: undefined
};

export const campaignManagementMenuItem = {
  name: 'Campaign Manager',
  url: '/campaign-management',
  icon: 'web',
  subMenu: undefined
};

export const inspectionSummaryMenuItem = {
  name: 'Inspection Summary',
  url: '/inspection-summary',
  icon: 'location_on',
  subMenu: undefined
};

export const inspectionHistoryMenuItem = {
  name: 'Inspection History',
  url: '/inspection-history',
  icon: 'history',
  subMenu: undefined
};

export const inspectorSummaryMenuItem = {
  name: 'Inspector Summary',
  url: '/inspector-summary',
  icon: 'people',
  subMenu: undefined
};

export const inspectorsMenuItem = {
  name: 'Inspectors',
  url: '/inspectors',
  icon: 'people_outline',
  subMenu: undefined
};

export const usersMenuItem = {
  name: 'Users',
  url: '/users',
  icon: 'manage_accounts',
  subMenu: undefined
};

export const appUsersMenuItem = {
  name: 'App users',
  url: '/app-users',
  icon: 'manage_accounts',
  subMenu: undefined
};

export const issueResolutionMenuItem = {
  name: 'Issue Resolution',
  url: '/issue-resolution',
  icon: 'dashboard',
  subMenu: undefined
};

export const agencyDashboardMenuItem = {
  name: 'Dashboard',
  url: '/dashboard',
  icon: 'pie_chart',
  subMenu: undefined
};

export const reprocessQueueItem = {
  name: 'Reprocess Queue',
  url: '/reprocess-queue',
  icon: 'memory',
  subMenu: undefined
};

export const settingsMenuItem = {
  name: 'Settings',
  url: '/settings',
  icon: 'settings',
  subMenu: undefined
};

// menu roles
export const adminMenu = [
  campaignManagementMenuItem,
  agencyDashboardMenuItem,
  issueResolutionMenuItem,
  qualityAssuranceMenuItem,
  inspectionHistoryMenuItem,
  campaignSummaryMenuItem,
  inspectionSummaryMenuItem,
  inspectorSummaryMenuItem,
  siteManagementMenuItem,
  referenceDataMenuItem,
  formatsMenuItem,
  dspsMenuItem,
  advertisersMenuItem,
  reportsMenuItem,
  adminMenuItem,
  inspectorsMenuItem,
  usersMenuItem,
  appUsersMenuItem,
  reprocessQueueItem,
  settingsMenuItem
];

export const staffMenu = [
  campaignManagementMenuItem,
  agencyDashboardMenuItem,
  issueResolutionMenuItem,
  qualityAssuranceMenuItem,
  inspectionHistoryMenuItem,
  campaignSummaryMenuItem,
  inspectionSummaryMenuItem,
  inspectorSummaryMenuItem,
  siteManagementMenuItem,
  referenceDataMenuItem,
  usersMenuItem,
  // reportsMenuItem
  settingsMenuItem
];

class Sidebar extends React.Component {
  constructor(props) {
    super(props)

    // set the menu role
    let menuRole = [];
    switch (props.role) {
      case ROLE_OIS_ADMIN:
        menuRole = [ ...adminMenu ];
        break;
      case ROLE_OIS_STAFF:
        menuRole = [ ...staffMenu ];
        break;
      case ROLE_MEDIA_OWNER:
        menuRole = [ campaignManagementMenuItem ];

        // only AU & NZ users see the dashboard nav item
        if (props.countryCode === 'AU' || props.countryCode === 'NZ') {
          menuRole.push(agencyDashboardMenuItem);
        }

        menuRole.push(issueResolutionMenuItem);

        if (props.access.indexOf('reference-data-management') > -1) {
          menuRole.push(referenceDataMenuItem);

          if (props.dashboard3Routes.includes('/formats')) {
            menuRole.push(formatsMenuItem);
          }
        }

        if (props.superUser || props.dashboard3Routes.includes('/users')) {
          menuRole.push(usersMenuItem);
        }

        if (props.superUser) {
          if (props.access.indexOf('app-user-management') > -1) {
            menuRole.push(appUsersMenuItem);
          }
        }

        if (props.dashboard3Routes.includes('/settings')) {
          menuRole.push(settingsMenuItem);
        }
        break;
      case ROLE_MEDIA_AGENCY:
        menuRole = [ campaignManagementMenuItem ];

        // only AU & NZ users see the dashboard nav item
        if (props.countryCode === 'AU' || props.countryCode === 'NZ') {
          menuRole.push(agencyDashboardMenuItem);
        }

        if (props.access.indexOf('advertiser-management') > -1) {
          menuRole.push(advertisersMenuItem);
        }

        if (props.access.indexOf('report-publisher-performance') > -1) {
          menuRole.push(reportsMenuItem);
        }

        if (props.superUser || props.dashboard3Routes.includes('/users')) {
          menuRole.push(usersMenuItem);
        }

        if (props.superUser) {
          if (props.access.indexOf('app-user-management') > -1) {
            menuRole.push(appUsersMenuItem);
          }
        }

        if (props.dashboard3Routes.includes('/settings')) {
          menuRole.push(settingsMenuItem);
        }
        break;
      case ROLE_CREATIVE_AGENCY:
        menuRole = [ campaignManagementMenuItem ];
        break;
      default:
        menuRole = [];
        break;
    }

    // get sidebar collapsed state from local storage
    const collapsed = window.localStorage.getItem('nav-collapsed') === 'true';

    this.state = {
      openMenu: undefined,
      showSideBar: false,
      menu: menuRole,
      collapsed
    }
  }

  isActive = (url) => {
    return url.length > 0 && this.props.match.url.includes(url);
  }

  isSubMenuOpen = (subMenu) => {
    if (subMenu === undefined || subMenu === null || subMenu.length === 0) {
      return false;
    }

    return subMenu.findIndex(q => this.props.match.url.includes(q.url)) > -1;
  }

  toggleSubMenu = (e, menuItem) => {
    this.setState((state) => ({
      openMenu: state.openMenu === menuItem.name || menuItem.url !== '' ? undefined : menuItem.name,
      showSideBar: menuItem.url === ''
    }));

    if (menuItem.url === '') {
      e.preventDefault();
    }
  }

  closeSideBar() {
    this.setState({
      showSideBar: false
    });
  }

  toggleSidebar() {
    this.setState(state => ({
      collapsed: !state.collapsed
    }), () => {
      // update local storage
      window.localStorage.setItem('nav-collapsed', this.state.collapsed);
    });
  }

  renderNavigationItem(obj) {
    const isOpen = this.state.openMenu === obj.name || this.isSubMenuOpen(obj.subMenu);
    return (
      <Fragment key={obj.name}>
        <NavLink
          className={'sidebar-tab' + (isOpen ? ' open' : '')}
          activeClassName='active'
          isActive={() => this.isActive(obj.url) || (this.state.collapsed && obj.subMenu && obj.subMenu.some((q) => this.isActive(q.url)))}
          to={obj.url}
          onClick={(e) => this.toggleSubMenu(e, obj)}
          title={obj.name}
        >
          <span className='material-icons'>{obj.icon}</span>
          {!this.state.collapsed && (<span className='side-label'>{obj.name}</span>)}
          {!this.state.collapsed && obj.subMenu && (<span className='material-icons right-align'>{isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</span>)}
        </NavLink>

        {!this.state.collapsed && isOpen && obj.subMenu.map((subMenuItem) => (
          <NavLink
            key={subMenuItem.name}
            className='sidebar-tab'
            activeClassName='active'
            isActive={() => this.isActive(subMenuItem.url)}
            to={subMenuItem.url}
            onClick={() => this.closeSideBar()}
            title={subMenuItem.name}
          >
            {this.props.simpleTheme && (<span className='material-icons sub-item-circle'>stop_circle</span>)}
            <span className='sub-side-label'>{subMenuItem.name}</span>
          </NavLink>
        ))}
      </Fragment>
    )
  }

  render() {
    const { menu } = this.state;
    return (
      <Fragment>
        <div className={'sidebar-left' + (this.state.collapsed ? ' sidebar-left--collapsed' : '')}>
          <div className='nav-logo'>
            <img
              alt='logo'
              src='https://dashboard-v3.oisooh.com/images/ois-logo-white.png'
              crossOrigin='anonymous'
            />
          </div>
          <nav className='sidebar-nav'>
            {menu.map((obj) => this.renderNavigationItem(obj))}
            {this.props.simpleTheme && (
              <a className='sidebar-tab' onClick={(e) => this.props.signOut()}>
                <span className='material-icons'>exit_to_app</span>
                {!this.state.collapsed && (<span className='side-label'>Sign Out</span>)}
              </a>
            )}
          </nav>
          {this.props.simpleTheme && (
            <button className={this.state.collapsed ? 'sidebar-tab navigation-toggle-btn navigation-toggle-btn--collapsed' : 'sidebar-tab navigation-toggle-btn'} onClick={() => this.toggleSidebar()} title='Open/Close Sidebar'>
              <span className='material-icons'>keyboard_double_arrow_left</span>
              {!this.state.collapsed && (<span className='side-label'>Collapse</span>)}
            </button>
          )}
          {!this.props.simpleTheme && (
            <a
              href='#main-menu-toggle'
              className='backdrop'
              tabIndex='-1'
              aria-hidden='true'
              hidden
            />
          )}
          {!this.props.simpleTheme && (
            <nav className='hide-on-desktop'>
              <Menu isOpen={this.state.showSideBar} width='350px'>
                {menu.map((obj, i) => this.renderNavigationItem(obj))}
              </Menu>
            </nav>
          )}
        </div>
      </Fragment>
    );
  }
}

export default Sidebar;
